<script>
/* eslint-disable vue/require-prop-types */
import UiPickerItem from './UiPickerItem.vue';

export default {
    functional: true,
    props: ['title', 'value', 'items'],

    render(h, {
        props, data, scopedSlots, listeners,
    }) {
        const inputCallback = item => (() => (listeners.input ? listeners.input(item) : null));

        return <div class="w-full" { ...data }>
            <p class="p-sm uppercase mt-sm text-elephant font-semibold">{ props.title }</p>
            { props.items.map(item =>
                <UiPickerItem onClick={inputCallback(item)} active={props.value === item}>{ scopedSlots.default({ item }) || item }</UiPickerItem>)}
        </div>;
    },
};
</script>
